import NotFound from './routes/NotFound.svelte'

import Initialize from './routes/Initialize.svelte'
import Message from './routes/Message.svelte'
import Welcome from './routes/Welcome.svelte'
import Treatment from './routes/Treatment.svelte'
import Employee from './routes/Employee.svelte'
import Schedule from './routes/Schedule.svelte'
import Customer from './routes/Customer.svelte'
import Confirm from './routes/Confirm.svelte'
import Processing from './routes/Processing.svelte'
import Verify from './routes/Verify.svelte'
import Validate from './routes/Validate.svelte'
import Success from './routes/Success.svelte'
import Failure from './routes/Failure.svelte'
import Cancelled from './routes/Cancelled.svelte'
import Error from './routes/Error.svelte'
import Chat from './routes/Chat.svelte'

export default [

    /* Catch all - must be first */
    { path: '*', component: NotFound },

    /* Error route without session */
    { path: '/error/(?<error>.*)', component: Error },

    /* Entry point */
    { path: '/(?<client>(?!error)[a-z0-9]+)/(?<salon>[a-z0-9]+)/verify' },
    { path: '/(?<client>(?!error)[a-z0-9]+)/(?<salon>[a-z0-9]+)' },

    /* Appointment booking flow with session validation */
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/initialize', component: Initialize },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/message', component: Message },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/welcome', component: Welcome, name: 'welcome' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/treatment', component: Treatment, name: 'treatment' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/employee', component: Employee, name: 'employee' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/schedule', component: Schedule, name: 'schedule' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/customer', component: Customer, name: 'customer' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/confirm', component: Confirm, name: 'confirm' },

    /* Inline AI chat (alternative layout) — no `name` so the step-completeness guard doesn't apply */
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/chat', component: Chat },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/verify', component: Verify },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/validate', component: Validate, name: 'validate' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/processing', component: Processing },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/success', component: Success, name: 'success' },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/failure', component: Failure },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/cancelled', component: Cancelled },
    { path: '/(?<client>[a-z0-9]+)/(?<salon>[a-z0-9]+)/(?<sessionId>[^/]+)/error/(?<error>.*)', component: Error }
]